/**
 * Utility for managing worktree/branch information
 */

// Get worktree name from environment variable
export const getWorktreeName = (): string => {
	return import.meta.env.VITE_WORKTREE_NAME || '';
};

// Format page title with worktree name
export const formatPageTitle = (pageTitle: string): string => {
	const worktreeName = getWorktreeName();
	if (worktreeName) {
		return `[${worktreeName}] ${pageTitle}`;
	}
	return pageTitle;
};

// Update document title with worktree prefix
export const updateDocumentTitle = (title: string): void => {
	if (typeof document !== 'undefined') {
		document.title = formatPageTitle(title);
	}
};
